"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_addins_core_1 = require("owa-addins-core");
exports.default = legacy_1.action('initializeExtensibilityContext')(function initializeExtensibilityContext() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Initializing the EXT context here is only needed for addins under the customSurfaceActions feature.
                    if (!owa_controls_feature_flags_1.isControlFeatureEnabled('rp-customSurfaceActions') ||
                        !owa_mail_feature_flags_1.isMailFeatureEnabled('rp-addins')) {
                        return [2 /*return*/];
                    }
                    // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                    return [4 /*yield*/, owa_addins_core_1.initExtensibilityContext.importAndExecute()];
                case 1:
                    // Init EXT context. This method has retry logic and will also resolve immediately if already initialized.
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeExtensibilityContext.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/actions/initializeExtensibilityContext.js
// module id = 3085
// module chunks = 2 3 4